<app-unit-resources *ngIf="resources" [unit]="unit" [resources]="resources"></app-unit-resources>
